import React from 'react';
import { Modal } from 'jd-library';
import styles from './commonStyle.scss';

const ProductNameModal = props => {
    return (
        <Modal
            settings={{
                modalId: 'ai-modals',
                variant: 'action',
                class: styles["ai-modals"],
            }}
            backdropStatic
            onHidden={props.onHidden}
            onVisible = {() => {props.recordImpression('nameReqModal')}}
        >
            <Modal.CloseIcon />
            <Modal.Header className={styles['modal-heading']}>{props.prodServLabel} Name Must be At Least 3 characters</Modal.Header>
            <Modal.Body className={styles['modal-body']}>The {props.prodServLabel.toLowerCase()} name must be at least 3 characters long to generate a meaningful description</Modal.Body>
            <Modal.CenterButton
                onClick={() => {
                    props.recordImpression('updtProdBtn');
                    window.history.back();
                    setTimeout(() => {
                        props.nameRef.scrollIntoView({ behavior: "smooth", block: "center" });
                        props.nameRef.focus();
                    }, 0);
                }}
            >
                Update {props.prodServLabel} Name
            </Modal.CenterButton>
        </Modal>
    )
}

export default ProductNameModal;